import { LIKELIHOOD_LEVELS } from "../likelihood";
import { ThresholdLines } from "@/Components/v2/molecule/BubbleChart/types";

/**
 * Determines the color for a data point based on which quadrant it falls into.
 * Quadrants are defined by threshold lines and each represents a likelihood level.
 */
export const getQuadrantColor = (x: number, y: number, thresholdLines: ThresholdLines) => {
  const isLeftQuadrant = x < thresholdLines.xAxis;
  const isBottomQuadrant = y < thresholdLines.yAxis;

  // Bottom-Left
  if (isLeftQuadrant && isBottomQuadrant) {
    return LIKELIHOOD_LEVELS.HIGH.color;
  }

  // Top-Left
  if (isLeftQuadrant && !isBottomQuadrant) {
    return LIKELIHOOD_LEVELS.MODERATE.color;
  }
  // Top-Right
  if (!isLeftQuadrant && !isBottomQuadrant) {
    return LIKELIHOOD_LEVELS.LOW.color;
  }

  // Bottom-Right
  return LIKELIHOOD_LEVELS.MODERATE.color;
};
